import React, { useEffect, useState } from "react";
import "./Reviews.css";
import Common_Title_2 from "../../common_components/common_title_2/Common_Title_2";
import { Swiper, SwiperSlide } from "swiper/react";
import { Rating } from "react-simple-star-rating";
import { Autoplay, Pagination } from "swiper/modules";
import { useDispatch, useSelector } from "react-redux";
import { getRating } from "../../../features/home/homeSlice";

const Reviews = ({ ratings }) => {
  const [rating, setRating] = useState(3);

  // Catch Rating value
  const handleRating = (rate) => {
    setRating(rate);
  };

  // Optional hover events
  const onPointerEnter = () => {
    // console.log("Enter");
  };

  const onPointerLeave = () => {
    // console.log("Leave");
  };

  const onPointerMove = (value, index) => {
    // console.log("Hover value:", value, "Index:", index);
  };

  // const ratings = useSelector((state) => state?.home?.rating);
  // const dispatch = useDispatch();
  // useEffect(() => {
  //   dispatch(getRating());
  // }, []);

  //  console.log(ratings,"ratingsratingsratingsratings")

  return (
    <section className="Reviews">
      <div className="container">
        <Common_Title_2 title={"Hear directly from our 10,00,000+ users"} />

        <div className="reviews_div">
          <Swiper
            spaceBetween={30}
            autoplay={{
              delay: 3000, // 3 seconds
              disableOnInteraction: false, // keeps autoplay after swipe
            }}
            modules={[Pagination, Autoplay]}
            pagination={{
              clickable: true,
            }}
            breakpoints={{
              0: { slidesPerView: 1.2, spaceBetween: 10 },
              360: { slidesPerView: 1.2, spaceBetween: 10 },
              425: { slidesPerView: 2.1, spaceBetween: 10 },
              640: { slidesPerView: 2.1, spaceBetween: 10 },
              768: { slidesPerView: 2.5, spaceBetween: 15 },
              992: { slidesPerView: 2.8, spaceBetween: 15 },
              1200: { slidesPerView: 3, spaceBetween: 15 },
              1400: { slidesPerView: 4, spaceBetween: 20 },
            }}
            className="mySwiper"
          >
            {/* {Array.from({ length: 4 })?.map((_, index) => (
              <SwiperSlide>
                <div className="review_card">
                  <div className="name_div">
                    <p className="inner_text">RK</p>
                  </div>

                  <p className="reviw_by_text">Ranbir Kapoor</p>
                  <p className="review_text">
                    Antigravity mattress - great experience & great comfort. The
                    latex 1-inch layer is very soft and below that form is firm
                    for great support. I like it very much.
                  </p>

                  <div className="rating_div">
                    <Rating
                      onClick={handleRating}
                      initialValue={rating}
                      size={20}
                    />
                  </div>
                </div>
              </SwiperSlide>
            ))} */}

            {Array.from({ length: 4 })?.map((_, index) => {
              const item = ratings?.[index];
              if (!item) return null;
              return (
                <SwiperSlide key={index}>
                  <div className="review_card">
                    <div className="name_div">
                      <p className="inner_text">
                        {item?.name
                          ?.trim()
                          ?.split(" ")
                          ?.filter(Boolean)
                          ?.map((word) => word[0])
                          ?.slice(0, 2)
                          ?.join("")
                          ?.toUpperCase()}
                      </p>
                    </div>

                    <p className="reviw_by_text">
                      {item?.name}
                    </p>

                    <p className="review_text">{item?.description}</p>

                    <div className="rating_div">
                      <Rating readonly initialValue={item?.rating} size={20} />
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default Reviews;
